import { CreateAutomationRequest } from '@app/models/requests';
// import { CampaignPageDesignsResponseInterface } from '@app/models/campaigns';
import { apiInstance } from './api';
import { ApiRoutes } from './consts';
import {AutomationReviewRequestStatusType} from "@app/models/automations.ts";

export const createAutomation = async (data: CreateAutomationRequest) => {
  return apiInstance.post(`${ApiRoutes.Automations}/create`, data);
};

export const getAutomations = async ({
  page,
  limit,
  sortBy,
  sortOrder,
  statuses,
  channels,
  tab,
  from,
  to,
  search,
}: {
  page: number;
  limit: number;
  sortBy: string | undefined;
  sortOrder: string;
  statuses?: string[];
  channels?: string[];
  tab?: string;
  from?: string;
  to?: string;
  search?: string;
}) => {
  // Build params object manually to avoid array serialization issues
  const params: any = {
    page,
    limit,
    sortBy,
    sortOrder,
    tab,
    from,
    to,
    search,
  };

  // Handle channels parameter
  if (channels && channels.length > 0) {
    if (channels.length === 1) {
      params.channels = channels[0];
    } else {
      params.channels = channels;
    }
  }

  // Handle statuses parameter - send as array
  if (statuses && statuses.length > 0) {
    params.statuses = statuses;
  }

  return apiInstance.get(`${ApiRoutes.Automations}/`, {
    params,
  });
};

export const getAutomation = async (id: string) => {
  return apiInstance.get(`${ApiRoutes.Automations}/${id}`);
};

export const getAutomationReviewRequests = async (automationId: string, page: number, limit: number, status?: AutomationReviewRequestStatusType)  => {
  return apiInstance.get(`${ApiRoutes.Automations}/${automationId}/review-requests`, {
    params: { page, limit, status },
  });
};

export const updateAutomation = async (
  id: string,
  data: Partial<CreateAutomationRequest>
) => {
  return apiInstance.put(`${ApiRoutes.Automations}/${id}`, data);
};

export const cancelAutomation = async (id: string) => {
  return apiInstance.post(`${ApiRoutes.Automations}/${id}/cancel`);
};


export const deleteAutomation = async (id: string) => {
  return apiInstance.delete(`${ApiRoutes.Automations}/${id}`);
};

export const pauseAutomation = async (id: string) => {
  return apiInstance.post(`${ApiRoutes.Automations}/${id}/pause`);
};

export const startAutomation = async (id: string) => {
  return apiInstance.post(`${ApiRoutes.Automations}/${id}/start`);
};

